import { Value } from './Value';
import { TypeMismatchError } from './error';
export class Schema {
    typeName;
    // abstract checkAssignsTo(value: Value): Schema.Mismatch | undefined;
    // abstract typeName:Value.TypeName
    constructor(typeName) {
        this.typeName = typeName;
    }
    get(...parts) {
        const steps = parts.flatMap(part => part.split('.'));
        if (steps.length === 0)
            return this;
        return Schema.UNDEFINED;
    }
}
(function (Schema) {
    class Struct extends Schema {
        fields;
        constructor(fields) {
            super('Struct');
            this.fields = fields;
        }
        assertAssignsTo(value) {
            Value.assertType('Struct', value);
            for (const key of Object.keys(value)) {
                const fieldSchema = this.fields[key];
                TypeMismatchError.hoist(key, () => {
                    if (!fieldSchema) {
                        Value.assertType('undefined', value);
                    }
                    else {
                        fieldSchema.assertAssignsTo(value[key]);
                    }
                });
            }
        }
        get(...path) {
            const steps = path.flatMap(step => step.split('.'));
            if (steps.length === 0)
                return this;
            const [step, ...rest] = steps;
            const fieldSchema = this.fields[step];
            return TypeMismatchError.hoist(step, () => {
                if (!fieldSchema)
                    return Schema.UNDEFINED;
                return fieldSchema.get(...rest);
            });
        }
    }
    class List extends Schema {
        itemSchema;
        constructor(itemSchema) {
            super('List');
            this.itemSchema = itemSchema;
        }
        assertAssignsTo(value) {
            Value.assertType('List', value);
            for (let i = 0; i < value.length; i++) {
                TypeMismatchError.hoist(i, () => {
                    this.itemSchema.assertAssignsTo(value[i]);
                });
            }
        }
    }
    class Primitive extends Schema {
        assertAssignsTo(value) {
            Value.assertType(this.typeName, value);
        }
    }
    class Integer extends Primitive {
        constructor() {
            super('number');
        }
        assertAssignsTo(value) {
            Value.assertType('number', value);
            if (!Number.isInteger(value)) {
                throw new TypeMismatchError('Integer', String(value));
            }
        }
    }
    class Any extends Schema {
        constructor() {
            super('undefined');
        }
        get() {
            return Schema.ANY;
        }
        assertAssignsTo(_value) {
            // no-op
        }
    }
    Schema.ANY = new Any();
    Schema.UNDEFINED = new Primitive('undefined');
    Schema.BOOLEAN = new Primitive('boolean');
    Schema.STRING = new Primitive('string');
    Schema.DOUBLE = new Primitive('number');
    Schema.INTEGER = new Integer();
    function struct(fields) {
        return new Struct(fields);
    }
    Schema.struct = struct;
    function list(itemSchema) {
        return new List(itemSchema);
    }
    Schema.list = list;
    function parse(schema) {
        if (schema.boolSchema) {
            return Schema.BOOLEAN;
        }
        if (schema.doubleSchema) {
            return Schema.DOUBLE;
        }
        if (schema.intSchema) {
            return Schema.INTEGER;
        }
        if (schema.stringSchema) {
            return Schema.STRING;
        }
        if (schema.listSchema) {
            if (!schema.listSchema.elementSchema)
                throw new TypeError('ListSchema must specify an elementSchema');
            return list(parse(schema.listSchema.elementSchema));
        }
        if (schema.structSchema) {
            return struct(mapValues(schema.structSchema.schema, parse));
        }
        throw new TypeError(`Unknown schema type ${schema}`);
    }
    Schema.parse = parse;
})(Schema || (Schema = {}));
function mapValues(record, callb) {
    const mapped = {};
    for (const key of Object.keys(record)) {
        mapped[key] = callb(record[key], key);
    }
    return mapped;
}
//# sourceMappingURL=Schema.js.map